// extracted by mini-css-extract-plugin
export default {"container":"tool-tip_container__sl+9I","tooltip":"tool-tip_tooltip__uAqq0"};